import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../images/confident_diver_logo.svg";
import axios from "axios";
import { IoClose } from "react-icons/io5";
import * as bootstrap from "bootstrap";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  // Base URL
  const baseUrl =
    process.env.REACT_APP_NODE_ENV === "production"
      ? process.env.REACT_APP_PRODUCTION_BASE_URL
      : process.env.REACT_APP_DEVELOPMENT_BASE_URL;

  const [settings, setSettings] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch settings (for logo)
  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/setting`);
      if (response.data.success) {
        setSettings(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  // Fetch programs dynamically
  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseUrl}/api/course/paginated?page=1&limit=50`);
        if (response.data.success) {
          // Normalize data
          const normalized = response.data.data
            .map((p) => ({
              ...p,
              showingDetails:
                typeof p.showingDetails === "string"
                  ? JSON.parse(p.showingDetails)
                  : p.showingDetails,
            }))
            .sort((a, b) => {
              const seqA = a.sequence ?? Number.MAX_SAFE_INTEGER;
              const seqB = b.sequence ?? Number.MAX_SAFE_INTEGER;
              return seqA - seqB;
            });
          setPrograms(normalized);
        }
      } catch (err) {
        console.error("Error fetching programs:", err);
        setError("Failed to load programs");
      } finally {
        setLoading(false);
      }
    };

    fetchPrograms();
  }, [baseUrl]);

  const handleLogoClick = (e) => {
    e.preventDefault();
    navigate("/");
  };

  const handleEnroll = (courseId) => {
    const modalEl = document.getElementById("programsModal");
    if (modalEl) {
      const modalInstance = bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();

        const backdrop = document.querySelector(".modal-backdrop");
        backdrop.remove();

        document.body.classList.remove("show");
        document.body.style = "";
      } else {
        const newModal = new bootstrap.Modal(modalEl);
        newModal.hide();


      }
    }

    // Wait a bit for modal animation to finish
    setTimeout(() => {
      navigate(`/program/${courseId}`);
    }, 300);
  };



  return (
    <>
      {/* 📘 Programs Modal */}
      <div
        className="modal fade programsModal"
        id="programsModal"
        tabIndex="-1"
        aria-labelledby="programsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h5 className="modal-title fw-semibold" id="programsModalLabel">
                Choose a Program
              </h5>
              <button
                type="button"
                className="btn btnclose"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <IoClose size={26} />
              </button>
            </div>

            <div className="modal-body list-body">
              <div className="maindetails">
                {loading ? (
                  <div className="text-center">Loading programs...</div>
                ) : error ? (
                  <div className="text-center text-danger">{error}</div>
                ) : programs.length === 0 ? (
                  <div className="text-center">No programs found</div>
                ) : (
                  <div className="accordion" id="programAccordion">
                    {programs.map((program, index) => (
                      <div className="accordion-item" key={program.courseId}>
                        <h2
                          className="accordion-header"
                          id={`heading${index}`}
                        >
                          <button
                            className={`accordion-button ${index !== 0 ? "collapsed" : ""
                              }`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${index}`}
                            aria-expanded={index === 0}
                            aria-controls={`collapse${index}`}
                          >
                            {program.programName}
                            <span
                              className="ms-auto price-tag"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEnroll(program.courseId);
                              }}
                              style={{
                                color: "#007bff",
                                cursor: "pointer",
                                fontWeight: "500",
                              }}
                            >
                              Enroll Now
                            </span>
                          </button>
                        </h2>
                        <div
                          id={`collapse${index}`}
                          className={`accordion-collapse collapse ${index === 0 ? "show" : ""
                            }`}
                          aria-labelledby={`heading${index}`}
                          data-bs-parent="#programAccordion"
                        >
                          <div className="accordion-body">
                            {program.programDescription || "No description"}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🌐 Navbar */}
      <nav className="navbar navbar-expand-lg" style={{ padding: "20px 0" }}>
        <div className="container">
          <a className="navbar-brand" href="#" onClick={handleLogoClick}>
            <img
              src={settings?.logoUrl ? `${baseUrl}${settings.logoUrl}` : logo}
              alt="Confident Driver Logo"
              className="logo"
              style={{ height: "75px", width: "auto" }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fa-solid fa-bars"></i>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mt-3 mt-lg-0 me-3">
              <li className="nav-item">
                <NavLink
                  to="/"
                  className={`nav-link ${location.pathname === "/" ? "active" : ""
                    }`}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/about"
                  className={`nav-link ${location.pathname === "/about" ? "active" : ""
                    }`}
                >
                  About Us
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  style={{
                    color: "#627a95",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#programsModal"
                >
                  Programs
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/contact"
                  className={`nav-link ${location.pathname === "/contact" ? "active" : ""
                    }`}
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
            <div>
              <button className="btn btn1 mt-3 mt-lg-0">Sign Up</button>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
